<template>
  <div class="article-card-sm"
    :class="{ border, shadow }"
    :style="[{ 'backgroundColor': backgroundColor }]"
  >
    <div class="img-box">
      <img class="icon-special-column" v-if="article.type === 'SpecialColumn'" src="./images/column.png"/>
      <img class="img" :src="article.cover.url" alt="" mode="aspectFill">
    </div>

    <div class="content flex column">
      <div class="title text-overflow-2">{{ article.title }}</div>

      <div class="extra self-end">
        <span class="view">{{ article.commentable_comment_datum.approved_comments_count | formatCount }} 评论</span>
        <span class="view">{{ article.likes_count | formatCount }} 赞</span>
        <span class="view" v-if="article.type === 'BookClub' || article.type === 'YouthCamp'">{{ article.applicants_count }}人报名</span>
        <span class="view" v-else>{{ article.views_count | formatCount }}人{{ article.type === 'Podcast' ? '听' : '看' }}过</span>
      </div>

    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ArticleCardSm extends Vue {
  @Prop({ type: Object, default: () => ({}) }) article;
  @Prop({ type: String, default: '#fff' }) backgroundColor
  @Prop(Boolean) border;
  @Prop(Boolean) shadow;
}
</script>

<style lang="scss" scoped>
  $text-color: #000;
  $text-color-secondary: #999;

  .article-card-sm {
    display: flex;
    padding: 15px 0;

    &.border {
      @include border-1px;
    }

    &.shadow {
      padding: 15px 16px;
      box-shadow: 0px 0px 12px 1px rgba(204, 204, 204, 0.36);
    }

    .img-box {
      position: relative;
      flex-shrink: 0;
      width: 70px;
      height: 70px;
      margin-right: 18px;
      overflow: hidden;

      .icon-special-column {
        position: absolute;
        top: 0;
        left: 0;
        width: 39px;
        height: 25px;
      }

      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .content {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 1.5;
        color: $text-color;
      }

      .extra {
        .view {
          font-size: 11px;
          text-align: right;
          color: $text-color-secondary;
        }

        .view + .view {
          margin-left: 16px;
        }
      }
    }
  }
</style>
